import React from "react";
import dayjs from "dayjs";
import "chart.js/auto";
import { Line } from "react-chartjs-2";
import { useGetInventoryPlotDataQuery } from "state/api";
import Loader from "components/Loader";
import DatePickerComponent from "components/GraphDatePickerComponent";

const options = {
  responsive: true,
  plugins: {
    legend: {
      display: false,
    },
    title: {
      display: false,
    },
    colors: {
      enabled: true,
    },
  },
  scales: {
    x: {
      grid: {
        display: false,
      },
      ticks: {
        color: "rgba(0, 0, 0, 0.54)",
      },
    },
    y: {
      grid: {
        display: false,
      },
      ticks: {
        color: "rgba(0, 0, 0, 0.54)",
      },
    },
  },
  elements: {
    line: {
      tension: 0.3,
    },
  },
};

const InventoryRangeGraph = () => {
  const [startDate, setStartDate] = React.useState(
    dayjs(new Date()).subtract(1, "month")
  );
  const [endDate, setEndDate] = React.useState(dayjs(new Date()));

  const handleStartDateChange = (date) => {
    setStartDate(date);
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
  };

  const { data: inventoryPlotData, isLoading } = useGetInventoryPlotDataQuery({
    startDate: startDate.format("YYYY-MM-DD"),
    endDate: endDate.format("YYYY-MM-DD"),
  });

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <div className="flex flex-col justify-center align-middle">
          <DatePickerComponent
            startDate={startDate}
            endDate={endDate}
            handleStartDateChange={handleStartDateChange}
            handleEndDateChange={handleEndDateChange}
          />
          <Line
            data={{
              labels: inventoryPlotData?.labels,
              datasets: [
                {
                  label: "Inventory Sold",
                  borderColor: "#ed6c02",
                  data: inventoryPlotData?.data,
                  fill: {
                    target: "origin",
                    above: "rgba(237, 108, 2, 0.2)",
                  },
                },
              ],
            }}
            options={options}
          />
        </div>
      )}
    </>
  );
};

export default InventoryRangeGraph;
